var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',_vm._g(_vm._b({staticClass:"ma-2 white--text",attrs:{"label":"","color":_vm.situacaoColor}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-truck")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }